import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getCompanyThemeApi = async (companyId) => {
    return vdkEmHappinessPortalApi.get(`/companies/${companyId}/theme`);
};
const updateCompanyThemeApi = async (request) => {
    const { companyId, ...theme } = request;
    return vdkEmHappinessPortalApi.put(`/companies/${companyId}/theme`, theme);
};
const CompanyThemeApi = {
    getCompanyThemeApi,
    updateCompanyThemeApi
};
export default CompanyThemeApi;
